import { useLangQuery } from '@hooks/useLangQuery';

import { fetchHeader } from './header.api';
import { QUERY_KEYS } from '../queries';

export const useHeaderQuery = () =>
  useLangQuery({
    queryKey: QUERY_KEYS.header,
    queryFn: fetchHeader,
    staleTime: 5 * 60 * 1000,
  });
